module.exports = __webpack_public_path__ + "img/9788982736346.3ef4ad98.jpg";